import React, { useRef, useState } from 'react';
import CustomScrollbar from 'components/Common/CustomScrollbar';
import ContentSummary from 'components/Dashboard/components/ContentSummary';
import LegislationOverviewContent from 'components/Dashboard/Legislation/LegislationOverviewContent';

const LegislationOverviewTab = ({ currentNew, heightContainer, hideSummary, shareButtonWidget }) => {
  const [scrolling, setScrolling] = useState(false);
  const scrollbarRef = useRef(null);

  return (
    <CustomScrollbar
      ref={scrollbarRef}
      className={'simple-scrollbar indented-scrollbar-small'}
      style={{ height: `${heightContainer - 70}px` }}
      minimalThumbYSize={55}
      maximalThumbYSize={100}
      onScrollStart={() => setScrolling(true)}
      onScrollStop={() => setScrolling(false)}
    >
      {!shareButtonWidget && <ContentSummary content={currentNew} hide={hideSummary} />}
      <div className='px-3 px-lg-4 pb-3 pb-lg-4'>
        <LegislationOverviewContent currentNew={currentNew} scrollbarRef={scrollbarRef} scrolling={scrolling} />
      </div>
    </CustomScrollbar>
  );
};

export default LegislationOverviewTab;
